import { StyleSheet, View } from 'react-native';

import { useGetVolunteerEvents } from '@/api/hooks/volunteerHooks';
import DotsLoader from '@/components/DotsLoader';
import VolunteerList from '@/components/volunteer/VolunteerList';
import PlatformContainer from '@/components/web/PlatformContainer';
import { useAuth } from '@/contexts/authContext';
import useGetLocation from '@/hooks/useGetLocation';
import { parsePointString } from '@/utils/parsePointString';

const VolunteerEngage = () => {
  const location = useGetLocation();
  const { state } = useAuth();

  const {
    data: volunteerEventsResponse,
    isLoading,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
    isRefetching
  } = useGetVolunteerEvents({
    n: 0,
    limit: 4,
    latitude: location?.latitude
      ? location?.latitude.toString()
      : state.user?.user.location
        ? parsePointString(state.user?.user.location ?? '').latitude.toString()
        : '37.0902', //USA Center
    longitude: location?.longitude
      ? location?.longitude.toString()
      : state.user?.user.location
        ? parsePointString(state.user?.user.location ?? '').longitude.toString()
        : '-95.7129' //USA Center
  });

  const volunteerEvents = volunteerEventsResponse?.pages.flatMap((page) => page.results);

  const onEndReached = () => {
    hasNextPage && !isFetching && fetchNextPage();
  };

  if (isLoading)
    return (
      <View style={style.container}>
        <DotsLoader />
      </View>
    );

  return (
    <PlatformContainer contentCustomClassnames="max-w-[1440px]">
      <View style={style.container}>
        <VolunteerList
          volunteerEvents={volunteerEvents}
          location={
            location?.latitude && location?.longitude && state.user?.user.location
              ? {
                  latitude: location?.latitude
                    ? location?.latitude
                    : state.user?.user.location
                      ? parsePointString(state.user?.user.location ?? '').latitude
                      : 37.0902, //USA Center
                  longitude: location?.longitude
                    ? location?.longitude
                    : state.user?.user.location
                      ? parsePointString(state.user?.user.location ?? '').longitude
                      : -95.7129 //USA Center
                }
              : null
          }
          onEndReached={onEndReached}
          refetch={refetch}
          isRefetching={isRefetching}
          isFetchingNextPage={isFetchingNextPage}
          canEdit={false}
        />
      </View>
    </PlatformContainer>
  );
};

export default VolunteerEngage;

const style = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  }
});
